import Vue from 'vue'
import Vuex from 'vuex'
import admin from './modules/admin'
import auth from './modules/auth'
import addresses from './modules/addresses'
import contactPersons from './modules/contactPersons'
import contracts from './modules/contracts'
import contractPartners from './modules/contractPartners'
import users from './modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    auth,
    addresses,
    contracts,
    contractPartners,
    contactPersons,
    users
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js